import { size, string } from "superstruct";
import { isStruct } from "../utils/isStruct";

export const PasswordStruct = size(string(), 6, Infinity);

export function isPassword(obj: unknown): obj is string {
  return isStruct(obj, PasswordStruct, "Password");
}
